import * as tslib_1 from "tslib";
import { OpenOverlayAction } from './open-overlay.action';
var OpenOverlayShrinkageAction = /** @class */ (function (_super) {
    tslib_1.__extends(OpenOverlayShrinkageAction, _super);
    /**
     * @param {OverlayService} overlayService
     */
    function OpenOverlayShrinkageAction(overlayService) {
        return _super.call(this, overlayService, 'sym-icon-shrinkage', 'APP.FORECAST.SETUP_SHRINKAGE') || this;
    }
    /**
     * Execute the action
     * @param {ActionConfiguration} actionConfiguration The action configuration
     */
    OpenOverlayShrinkageAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                input.actionConfiguration.configuration = {
                    components: [
                        {
                            component: 'ShrinkageComponent',
                            configuration: {}
                        }
                    ],
                    icon: this.getIcon(),
                    labelKey: this.getLabelKey(),
                    instruction: 'instructions/standaard/forecast/actions/setup-shrinkage'
                };
                return [2 /*return*/, _super.prototype.do.call(this, input)];
            });
        });
    };
    return OpenOverlayShrinkageAction;
}(OpenOverlayAction));
export { OpenOverlayShrinkageAction };
